import dayjs from 'dayjs';
import type { ModelPlanPayment } from '@layup/api-sdk';

export const getPaymentStatus = (payment: ModelPlanPayment) => {
  if (payment.failed) {
    return 'Failed';
  } else if (payment.paymentType === 'REFUND') {
    return 'Refunded';
  } else if (payment.paid && !payment.reconciliated) {
    return 'Pending';
  } else if (payment.paid) {
    return 'Paid';
  } else if (dayjs().isAfter(payment.dueAt)) {
    return 'Overdue';
  } else if (dayjs().isSame(payment.dueAt, 'day')) {
    return 'Due';
  } else {
    return 'Upcoming';
  }
};

// There is a confusion happening because we first do this check if (payment.paid && !payment.reconciliated)
// which means that if a payment is paid but not reconciliated, it will be marked as pending
// and then we have another check below which checks if the payment is paid and reconciliated & if so, it will be marked as paid.
// This is a temporary fix to avoid the confusion. So customer see payment as paid after completing the transaction successfully even before reconciliated
export const getPaymentStatusRegardlessOfReconciliated = (payment: ModelPlanPayment) => {
  if (payment.failed) {
    return 'Failed';
  } else if (payment.paymentType === 'REFUND') {
    return 'Refunded';
  } else if (payment.paid) {
    return 'Paid';
  } else if (dayjs().isAfter(payment.dueAt)) {
    return 'Overdue';
  } else if (dayjs().isSame(payment.dueAt, 'day')) {
    return 'Due';
  } else {
    return 'Upcoming';
  }
};

export const getPaymentStatusVariant = (status: string) => {
  let variant:
    | 'destructive'
    | 'outline'
    | 'secondary'
    | 'default'
    | 'warning'
    | 'brand'
    | 'success'
    | 'info'
    | 'error'
    | null
    | undefined = undefined;

  switch (status) {
    case 'Refunded':
      variant = 'warning';
      break;
    case 'Pending':
      variant = 'info';
      break;
    case 'Paid':
      variant = 'success';
      break;
    case 'Overdue':
      variant = 'error';
      break;
    case 'Due':
      variant = 'warning';
      break;
    case 'Failed':
      variant = 'error';
      break;
    case 'Upcoming':
      variant = 'outline';
      break;
    default:
      variant = 'default';
      break;
  }
  return variant;
};

export const getPaymentStatusClasses = (status: string) => {
  let classes = '';

  switch (status) {
    case 'Refunded':
      classes = 'bg-yellow-100 text-yellow-800 text-[12px]';
      break;
    case 'Pending':
      classes = 'bg-blue-100 text-blue-800 text-[12px]';
      break;
    case 'Paid':
      classes = 'bg-success-50 text-success-800 border-success-200 text-[12px]';
      break;
    case 'Overdue':
      classes = 'border-error-200 bg-error-50 text-error-800 text-[12px]';
      break;
    case 'Due':
      classes = 'bg-orange-100 text-orange-800 text-[12px]';
      break;
    case 'Failed':
      classes = 'border-error-200 bg-error-50 text-error-800 text-[12px]';
      break;
    case 'Upcoming':
      classes = 'border-grey-light-200 bg-grey-light-50 text-grey-light-800 text-[12px]';
      break;
    case 'Processing':
      classes = 'border-[#F9DBAF] bg-[#FEF6EE] text-[#F9DBAF] text-[12px]';
      break;
    default:
      classes = 'bg-gray-100 text-gray-800 text-[12px]';
      break;
  }

  return classes;
};
